export default __webpack_public_path__ + "static/media/IPODocuments-01.c7a2f979.jpg";